import type { BreadcrumbMatch } from "@/types/router-breadcrumb";
import {
  BreadcrumbsWrapper,
  Button,
  Heading,
  Icon,
} from "@elaniintc/goes-design-system";
import { useMatches, useNavigate } from "react-router";

function truncateLabel(str: string, max = 50) {
  return str.length > max ? `${str.slice(0, max)}…` : str;
}

export function AppBreadcrumb() {
  const matches = useMatches() as BreadcrumbMatch[];
  const navigate = useNavigate();

  const currentMatch = matches[matches.length - 1];
  const handle = currentMatch?.handle;
  const rawCrumbs = handle?.breadcrumb(currentMatch) || [];

  const breadcrumbs = rawCrumbs.map(({ label, path, goBack }) => ({
    label: truncateLabel(label, 40),
    path,
    goBack,
  }));

  if (breadcrumbs.length === 1 && !breadcrumbs[0].path) {
    return (
      <Heading variant="h6" className="font-semibold">
        {breadcrumbs[0].label}
      </Heading>
    );
  }

  const previous = breadcrumbs[breadcrumbs.length - 2];

  return (
    <div className="flex gap-4 items-center text-body">
      {previous?.path && (
        <Button
          onClick={() => navigate(previous.path!)}
          variant="quiet"
          size="sm"
          className="size-9"
        >
          <Icon type="far" name="angle-left" className="text-current text-sm" />
          <span className="sr-only">Volver a {previous.label}</span>
        </Button>
      )}
      {previous?.goBack && (
        <Button
          onClick={() => navigate(-1)}
          variant="quiet"
          size="sm"
          className="size-9"
        >
          <Icon type="far" name="angle-left" className="text-current text-sm" />
          <span className="sr-only">Volver a {previous.label}</span>
        </Button>
      )}
      <BreadcrumbsWrapper
        items={breadcrumbs.map(({ label, path }, index) => ({
          label,
          isCurrentPage: index === breadcrumbs.length - 1,
          onClick: () => {
            if (path) navigate(path);
          },
        }))}
      />
    </div>
  );
}
